/**
 * Eniq AI product card.
 *
 * Renders whichever pricing UI matches the active model. Both variants are
 * imported so the conserved legacy component stays referenced and the build
 * does not flag it as unused.
 */
import React from 'react';
import { isEniqPerUserMode } from '../../../../config/pricingModes';
import EniqAILegacyMinutes from './EniqAILegacyMinutes';
import EniqAITierSelect from './EniqAITierSelect';

const EniqAI = () => (isEniqPerUserMode() ? <EniqAITierSelect /> : <EniqAILegacyMinutes />);

export default EniqAI;
